import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  border-bottom: 1px solid #B9B7CC;
  h4 {
    color: #F78764;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  h2 {
    color: #000;
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 14px;
  }
  .breadcrumbs {
    color: #A09FAA;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 28px;
    span {
      color: #279CD9;
    }
  }
`;

export const FiltroBasico = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const Totais = styled.div`
  margin-bottom: 24px;
  span {
    font-weight: 600;
  }
`;

export const BoletoListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  background-color: #FFFFFF;
  border-radius: 4px;
  margin-bottom: 10px;
  height: 90px;
  padding: 0 32px;

  .coluna span {
    font-weight: 600;
  }

  .coluna {
    &-empresa {
      flex: 0 1 280px;
      h4 {
        color: #423B8D;
        font-size: 16px;
        margin-bottom: 4px;
      }
      p {
        color: #666;
        font-size: 13px;
        margin: 0;
      }
    }
    &-data {
      flex: 0 1 150px;
      h4 {
        color: #271946;
        font-size: 14px;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 4px;
      }
    }
    &-valor {
      flex: 0 1 120px;
      h4 {
        color: #271946;
        font-size: 14px;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 4px;
      }
      font-weight: 600;
      font-size: 16px;
    }
    &-status {
      flex: 0 1 120px;
      h4 {
        color: #271946;
        font-size: 14px;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 4px;
      }
    }
    &-actions {
      margin-left: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto;
    padding: 20px;
    .coluna {
      &-empresa, &-data, &-valor, &-status, &-actions {
        flex: 1 0 100%;
        padding: 8px 0;
      }
      &-actions {
        margin-left: 0px;
        align-self: stretch;
        justify-content: space-between;
      }
    }
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  margin: 0 8px;
  height: 48px;
  transition: 300ms ease;

  span {
    color: #279CD9;
    font-size: 14px;
    padding-left: 6px;
    text-transform: uppercase;
    font-weight: 600;
  }

  &:hover {
    transform: scale(0.9);
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  background-color: ${props => props.color}20;
  color: ${props => props.color};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid ${props => props.color}40;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  background-color: #ffffff;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalBody = styled.div`
  padding: 30px 40px;
  text-align: center;

  h3 {
    color: #271946;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  p {
    color: #666;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 0;

    strong {
      color: #271946;
      font-weight: 600;
    }
  }
`;

export const ModalFooter = styled.div`
  padding: 20px 40px 30px;
  display: flex;
  gap: 12px;
  justify-content: center;
  border-top: 1px solid #e0e0e0;
`;
